import woman from "../../assets/images/woman-contactus.webp";

export default function ContactUsImage(){
    return(
        <div className="image pt-3 pt-md-0">
            <img className="img-fluid" src={woman} alt="Imágen mujer contacto" />
        </div>
    )
}
